import {
    CONDITIONS,
    CONDITION_NAME,
    OPERATORS,
    VALUES
} from "../misc/constants";
import { Col, Row } from "reactstrap";

import FieldArrays from "@components/fields/field-arrays";
import InputField from "@components/fields/input-field";
import Select from "@components/fields/react-select/select";
import { useFieldArray } from "react-hook-form";

export const Conditions = props => {

    const { methods, type, name } = props;

    const { control, formState:{ errors }, watch, setValue } = methods;

    const { fields } = useFieldArray({
        control,
        name
    });
    return (
        <FieldArrays
            fields={fields}
            subject="life-cycle"
            disabledAppend={true}
            disabledRemove={true}
            render={index => (
                <Row key={index}>
                    <Col md={6}>
                        <Select
                            label="Condition"
                            required
                            errors={errors[name]?.[index]}
                            id="condition"
                            name={`${name}.${index}.condition`}
                            control={control}
                            options={CONDITIONS(type)}/>
                    </Col>
                    {watch(`${name}.${index}.condition`) !==
                                "manually_start" && (
                        <>
                            <Col md={6}>
                                <Select
                                    label="Condition Name"
                                    required
                                    errors={errors[name]?.[index]}
                                    id="name"
                                    onCustomChange={() => {
                                        setValue(`conditions.${index}.name`, "");
                                        setValue(`conditions.${index}.operator`, "");
                                        setValue(`conditions.${index}.value`, "");
                                    }}
                                    name={`${name}.${index}.name`}
                                    control={control}
                                    options={CONDITION_NAME(
                                        watch(
                                            `${name}.${index}.condition`
                                        )
                                    )}/>
                            </Col>
                            {watch(`${name}.${index}.condition`) ===
                                    "attribute" ? (
                                    <>
                                        <Col md={6}>
                                            <Select
                                                label="Operator"
                                                required
                                                id="operator"
                                                onCustomChange={() => {
                                                    setValue(`conditions.${index}.value`, "");
                                                }}
                                                name={`${name}.${index}.operator`}
                                                control={control}
                                                errors={errors[name]?.[index]}
                                                options={
                                                    OPERATORS
                                                }/>
                                        </Col>
                                        <Col md={6}>
                                            <InputField
                                                label="Value"
                                                required
                                                id="value"
                                                errors={errors[name]?.[index]}
                                                name={`${name}.${index}.value`}
                                                type="number"
                                                control={control}
                                                prefix={{ txt: "$" }}/>
                                        </Col>
                                    </>
                                ) : (
                                    <Col md={6}>
                                        {" "}
                                        <Select
                                            label="Value"
                                            required
                                            id="value"
                                            errors={errors[name]?.[index]}
                                            name={`${name}.${index}.value`}
                                            control={control}
                                            options={VALUES(
                                                watch(
                                                    `${name}.${index}.name`
                                                )
                                            )}/>{" "}
                                    </Col>
                                )}
                        </>
                    )}
                </Row>
            )}/>
    );
};
